
export default function NotFound() {
    return (
        <div className="not-found">
            NOT FOUND 404
        </div>
    );
}